import { render, staticRenderFns } from "./TsSelectCustomer.vue?vue&type=template&id=6b94b896&scoped=true&"
import script from "./TsSelectCustomer.vue?vue&type=script&lang=js&"
export * from "./TsSelectCustomer.vue?vue&type=script&lang=js&"
import style0 from "./TsSelectCustomer.vue?vue&type=style&index=0&id=6b94b896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b94b896",
  null
  
)

export default component.exports